import { useContext } from 'react'
import { ExpoContext } from '../ExpoContext'

const useExpoContext = () => {
  const context = useContext(ExpoContext)
  if (!context) {
    throw new Error('useExpoContext must be used within a ExpoContextProvider')
  }
  return context
}
export default useExpoContext
